var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.5859C5.59375 10.5859 5.28906 10.2812 5.28906 9.875V8.25C5.28906 7.86914 5.59375 7.53906 6 7.53906C6.38086 7.53906 6.71094 7.86914 6.71094 8.25V9.875C6.71094 10.2812 6.38086 10.5859 6 10.5859ZM11.6875 6.21875V11.9062C11.6875 12.5918 11.1289 13.125 10.4688 13.125H1.53125C0.845703 13.125 0.3125 12.5918 0.3125 11.9062V6.21875C0.3125 5.55859 0.845703 5 1.53125 5H2.34375V3.78125C2.34375 1.77539 3.96875 0.125 6 0.125C8.03125 0.150391 9.65625 1.80078 9.65625 3.83203V5H10.4688C11.1289 5 11.6875 5.55859 11.6875 6.21875ZM3.5625 5H8.4375V3.78125C8.4375 2.46094 7.32031 1.34375 6 1.34375C4.6543 1.34375 3.5625 2.46094 3.5625 3.78125V5ZM10.4688 6.21875H1.53125V11.9062H10.4688V6.21875Z",
    fill: "#DC3545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.ee66344e.svg";
export { ForwardRef as ReactComponent };